<template>
  <div class="is-kyoutei edit-item" v-if="editingData && options">

    <div class="head"><b>協定対象派遣</b></div>
    <div class="data">
      <input-radio :options="options.kyoutei_type" v-model="editingData.is_kyoutei" :disabled="disabled"></input-radio>
      <p class="current-data" v-if="currentData?.is_kyoutei === true">協定対象派遣労働者である</p>
      <p class="current-data" v-else-if="currentData?.is_kyoutei === false">協定対象派遣労働者ではない</p>
    </div>

  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent, watchEffect } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup(props) {
    // 協定対象派遣ではない場合は、当該協定の有効期間の終了日をNULLにする
    watchEffect(() => {
      if(props.editingData) {
        if (props.editingData.is_kyoutei === false) {
          props.editingData.kyoutei_end_date = null;
        }
      }
    })
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
